import { FunctionComponent, memo } from "react";
import { IProps, PhraseTriggerMessageSource } from "./select-message-source.types";
import { SelectEnum } from "@edgetier/select";
import "./select-message-source.scss";

/**
 * Select a message source from "Customer", "Agent" or "Bot".
 */
const SelectMessageSource: FunctionComponent<IProps> = ({ ...selectProps }) => {
    return (
        <SelectEnum
            description="message source"
            name="messageSource"
            items={PhraseTriggerMessageSource}
            {...selectProps}
        />
    );
};

export default memo(SelectMessageSource);
